import { ScaleElement } from '@scale/base-element';
import { FiltersUpdatedEvent } from '@scale/events';

class ScaleFacets extends ScaleElement {
  setup() {
    window.addEventListener('popstate', () => this.#onPopState(), { signal: this.signal });
  }

  handleFilterChange() {
    this.debounce('filter', () => this.#apply(), 50);
  }

  handleSortChange() {
    this.#apply();
    this.closeDrawer();
  }

  handleClearFilter(event) {
    event.preventDefault();
    const url = event.target.closest('a')?.href;
    if (url) this.#navigate(url);
  }

  handleClearAll(event) {
    event.preventDefault();
    const url = event.target.closest('a')?.href;
    if (url) this.#navigate(url);
  }

  openDrawer() {
    const drawer = document.getElementById('filter-drawer');
    if (drawer) drawer.open();
  }

  closeDrawer() {
    const drawer = document.getElementById('filter-drawer');
    if (drawer) drawer.close();
  }

  #apply() {
    const url = this.#buildURL();
    history.pushState({}, '', url);
    this.broadcast(new FiltersUpdatedEvent(url));
  }

  #navigate(url) {
    history.pushState({}, '', url);
    this.broadcast(new FiltersUpdatedEvent(url));
  }

  #onPopState() {
    this.closeDrawer();
    this.broadcast(new FiltersUpdatedEvent(window.location.href));
  }

  #buildURL() {
    const form = this.ref('form');
    if (!form) return window.location.href;

    const formData = new FormData(form);
    const params = new URLSearchParams();

    for (const [key, value] of formData.entries()) {
      if (value === '' || value == null) continue;
      params.append(key, value);
    }

    params.delete('page');
    const url = new URL(window.location.pathname, window.location.origin);
    url.search = params.toString();
    return url.toString();
  }
}

if (!customElements.get('scale-facets')) {
  customElements.define('scale-facets', ScaleFacets);
}
